import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';
import { isPreviewOnly } from '@src/page/toc/common/check-client-vars';
import { PPTEditorStateEnumType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { presetClassTypes } from '@src/slide/domain/ui-model/element-modeles/property/animation/constant';

@Feature()
export class AnimBrushFeature extends BaseToolbarFeature {
    public id = config.id;
    public config = config;

    public constructor() {
        super();
    }

    public onClick() {
        this.getAnimBrushManager()?.onClickButton();
        // this.twdReport();
    }

    public onDoubleClick() {
        this.getAnimBrushManager()?.onDoubleClickButton();
        // this.twdReport();
    }

    public shouldDisabled(): boolean {
        if (
            isPreviewOnly()
            || this.isHistoryShown()
            || this.getUserPriviledgeService().pptEditorState !== PPTEditorStateEnumType.EDITABLE) return true;

        const selectedElementList = this.getSelectionService()?.selectedElements?.selectedArray?.filter(el => !!el);
        let selectedAnimList: any[] = [];
        if (selectedElementList?.length === 1) {
            selectedAnimList = selectedElementList[0].animList.filter(anim =>
                !!anim && anim?.props?.presetClass !== presetClassTypes.PATH); // 过滤路径动画和非动画元素
        }
        // 未选中元素或者选中元素无动画均禁用动画刷
        return !selectedElementList?.length || !selectedAnimList?.length;
    }

    public isChecked(): boolean {
        return !!this.getAnimBrushManager()?.animBrushState;
    }

    public getAnimBrushManager() {
        return this.getAppService().editableServiceLayer?.animBrushManager;
    }

    private isHistoryShown() {
        return this.getAppService().editableServiceLayer?.historyManager.isShown();
    }
}
